module.exports = __webpack_public_path__ + "assets/twitch.d44afe93.svg";